import React from 'react'
import { FontIcon, Button, Tooltipped, SimplePosition } from 'react-md'
import { usePromiseTracker } from 'react-promise-tracker'

import { useAuth } from 'contexts/auth/auth-context'
import { Theme } from 'contexts/auth/types'

interface Props {
  id: string
  tooltip?: string
  tooltipPosition?: SimplePosition
  action: () => void
  disabled?: boolean
}

const EditButton: React.FC<Props> = ({ id, tooltip, tooltipPosition, action, disabled }) => {
  const { promiseInProgress } = usePromiseTracker()
  const { theme } = useAuth()

  return (
    <Tooltipped id={id} tooltip={tooltip || 'Editar'} position={tooltipPosition || 'above'}>
      <Button
        theme={disabled || promiseInProgress ? 'disabled' : 'clear'}
        disabled={disabled || promiseInProgress}
        buttonType='icon'
        style={
          disabled || promiseInProgress
            ? { margin: 2 }
            : theme === Theme.Dark
            ? { margin: 2, backgroundColor: '#0277BD', color: '#FFFFFF' }
            : { margin: 2, backgroundColor: '#4FC3F7', color: '#212121' }
        }
        onClick={action}>
        <FontIcon>edit</FontIcon>
      </Button>
    </Tooltipped>
  )
}

export default EditButton
